import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { defer, Observable, tap } from 'rxjs';
import { BusyService } from './busy.service';

@Injectable({ providedIn: 'root' })
export class DownloadService {
  constructor(private httpClient: HttpClient, private busyService: BusyService) {}

  download(message: string, fileName: string, request: (httpClient: HttpClient) => Observable<Blob>): Observable<any> {
    return defer(() =>
      this.busyService
        .busy$(message, request(this.httpClient))
        .pipe(tap((blob) => this.downloadInternal(blob, fileName)))
    );
  }

  private downloadInternal(blob: Blob, filename: string): void {
    const blobUrl = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = blobUrl;
    link.target = '_self';

    if (filename) {
      link.download = filename;
    }

    link.click();

    // needs timeout because Firefox removes the object before the actual download
    window.setTimeout(() => {
      URL.revokeObjectURL(blobUrl);
    }, 100);
  }
}
